import React, { memo } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "../Header/common/Container";
import imageLogo from "../../assets/Images/logo.png";
import { Link } from "react-router-dom";
import { MenuType } from "./typing";
import MenuMain from "./MenuMain";
import MenuMobile from "./MenuMobile";
import Profile from "./Profile";

const pages: MenuType[] = [
  {
    id: 1,
    title: "HOME",
    link: "/home",
  },
  {
    id: 2,
    link: "/about-us",
    title: "ABOUT US",
  },
  {
    id: 3,
    title: "PLANTS",
    link: "/products-plants",
  },
];

const Header: React.FC<{}> = () => {
  return (
    <AppBar
      position="fixed"
      elevation={0}
      id="back-to-top-anchor"
      sx={{
        bgcolor: "background.header",
        color: "text.body",
        zIndex: (theme) => theme.zIndex.appBar,
        top: 0,
        left: 0,
        right: 0,
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        overflowY: "visible",
        /* Tách layer compositing — cuộn trang mượt hơn, header không “nhảy” như sticky */
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
        boxShadow: "0 1px 0 rgba(0,0,0,0.08)",
      }}
    >
      <Container maxWidth={false} sx={{ width: "100%", maxWidth: "100%", px: { xs: 1, sm: 2 } }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 0.75,
            /* md+ logo 70px — minHeight 64 khiến hàng thực tế ~70px, lệch với padding main */
            minHeight: { xs: 56, md: 72 },
            minWidth: 0,
            width: "100%",
            maxWidth: "100%",
          }}
        >
          <Link
            to="/home"
            style={{ display: "flex", flexShrink: 0, alignItems: "center", textDecoration: "none" }}
          >
            <Box
              component="img"
              src={imageLogo}
              alt="TBT Groups"
              sx={{
                width: { xs: 44, md: 70 },
                height: { xs: 44, md: 70 },
                objectFit: "contain",
                display: "block",
              }}
            />
          </Link>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flex: 1,
              minWidth: 0,
              justifyContent: "flex-end",
              gap: 0,
            }}
          >
            <Toolbar
              disableGutters
              variant="dense"
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                minHeight: 0,
                flexShrink: 0,
              }}
            >
              <MenuMain pages={pages} />
            </Toolbar>
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              <Profile />
            </Box>
            <MenuMobile />
          </Box>
        </Box>
      </Container>
    </AppBar>
  );
};
export default memo(Header);
